let api = "";
let redirect = "";
if (window.location.hostname === "localhost") {
  api = "https://improved-bassoon-w4w5vwwg4492g6xq-7071.app.github.dev";
  redirect = "http://localhost:3000";
} else {
  redirect = "https://genesys-wrapup-codes.ccaas.maximuscanada.dev";
}

if (window.location.hostname === "localhost") {
  console.log(true, api);
}

export const ENV = {
  cac1: {
    DEV: {
      orgName: "DEV",
      id: "4ad137fb-84f9-465d-8a1b-dfaf43af4d1c",
      clientId: process.env.REACT_APP_CLIENT_ID_DEV,
      name: "maximuscanada-dev",
    },
    FEC: {
      orgName: "FEC",
      clientId: process.env.REACT_APP_CLIENT_ID_FEC,
    },
    ICC: {
      orgName: "ICC",
      clientId: process.env.REACT_APP_CLIENT_ID_ICC,
    },
    MAX: {
      orgName: "MAX",
      clientId: process.env.REACT_APP_CLIENT_ID_MAX,
    },
    ODB: {
      orgName: "ODB",
      clientId: process.env.REACT_APP_CLIENT_ID_ODB,
    },
    SBC: {
      orgName: "SBC",
      clientId: process.env.REACT_APP_CLIENT_ID_SBC,
    },

    SDO: {
      orgName: "SDO",
      clientId: process.env.REACT_APP_CLIENT_ID_SDO,
    },
    TIM: {
      orgName: "TIM",
      clientId: process.env.REACT_APP_CLIENT_ID_TIM,
    },
  },
  redirect,
  api,
};